(function() {
  'use strict';

  function PagamentoCtrl (
    $q,
    $scope,
    $state,
    $stateParams,
    localStorageService,
    Perfil,
    Pedido,
    Pagamento,
    Utils,
    Auth,
    Cliente,
  ) {

    $scope.utilizarCupom = false;
    $scope.codigoCupom = localStorageService.get('codigoCupom');
    $scope.checkPJ = {
      value: false
    };

    var plan = Perfil.getCacheUserData().planoContrato.tipo;
    if (plan === 'SOFT') {
      $scope.freteValor = 'O valor é baseado no preço dos Correios e uma taxa única de serviço de R$ 25 por coleta.';
    } else {
      $scope.freteValor = 'O valor é baseado no preço dos Correios e uma taxa única de serviço conforme as condições do seu plano.';
    }

    // se cartao habilitado = true,
    // se cartao desabilitado = false,
    // se cartao nao existe = null.
    var cartaoHabilitado = null;

    // sera utilizada ao habilitar ou desabilitar a forma pagamento.
    var idFormaPagamento = null;

    // verifica se o usuario é tex
    // apagar qnd tex for para todos
    function verificaTex (remessas) {
      var i = 0;
      $scope.isTex = null;
      for (i in remessas) {
        if (remessas[i].servicoEnvio === 'MandaeEconomico' || remessas[i].servicoEnvio === 'MandaeExpress') {
          $scope.isTex = true;
        }
      }
    }

    function definirCheckNF () {
      // Pega o cnpj.
      var cnpj = $scope.cpfcnpj && $scope.cpfcnpj.length == 14 ? $scope.cpfcnpj : null;
      var isPj = Auth.isPJ();

      if (cnpj || isPj) {
        $scope.checkPJ.value = true;
      }
    }

    function definirDisabled () {
      // Pega o cpf ou cnpj.
      var cpf = $scope.cpfcnpj && $scope.cpfcnpj.length == 11 ? $scope.cpfcnpj : null;
      var cnpj = $scope.cpfcnpj && $scope.cpfcnpj.length == 14 ? $scope.cpfcnpj : null;

      if (cpf || cnpj) {
        $scope.desabilitarCpfCnpj = true;
        $scope.desabilitarCheckPJ = true;
      } else {
        $scope.desabilitarCpfCnpj = false;
      }

      if ($scope.razaoSocial) {
        $scope.desabilitarRazaoSocial = true;
      } else {
        $scope.desabilitarRazaoSocial = false;
      }

      if ($scope.inscricaoEstadual) {
        $scope.desabilitarInscricaoEstadual = true;
      } else {
        $scope.desabilitarInscricaoEstadual = false;
      }
    }

    function trocaTexto (contrato) {
      if (contrato.contratoRecorrencia === 1) {
        $scope.textoContrato = 'Como você prefere pagar pelo nosso serviço?';
      } else if (contrato.contratoRecorrencia === 2) {
        $scope.textoContrato = 'Como você prefere pagar sua fatura semanal?';
      } else if (contrato.contratoRecorrencia === 3) {
        $scope.textoContrato = 'Como você prefere pagar sua fatura mensal?';
      }
    }

    function selecionaEstado (estado, edit) {
      // se edit for true, seleciona o estado default pois está vindo da edição
      if (edit || estado === 0) {
        $scope.formaPagamento = '';
      } else {
        $scope.formaPagamento = estado;
      }
    }

    function montarOptions (enabled, cartao, plano) {
      // 0 - valor de cartão desabilitado
      // 1 - valor de cartão habilitado
      // 2 - valor de Alterar cartão
      // 3 - valor de boleto
      // 4 - valor de cartão de credito quando NÃO cadastrado

      if (enabled === true) {
        $scope.options = [{
          'text': cartao.formaPagamento.bandeira + ' terminado em ' + cartao.formaPagamento.ultimosNumeros,
          'value': 1
        }, {
          'text': 'Trocar o Cartão',
          'value': 2
        }];
        selecionaEstado(1, $stateParams.estado);
      } else if (enabled === false) {
        $scope.options = [{
          'text': cartao.formaPagamento.bandeira + ' terminado em ' + cartao.formaPagamento.ultimosNumeros,
          'value': 0
        }, {
          'text': 'Trocar o Cartão',
          'value': 2
        }];
        selecionaEstado(0, $stateParams.estado);
      } else {
        $scope.options = [{
          'text': 'Cartão de Crédito',
          'value': 4
        }];
      }
      if (plano === 'freedom' || plano === 'flex') {
        $scope.options.push({text: 'Boleto', value: 3});
      }
    }

    // reseta form de alterar cartao
    $scope.changeFormaPagamento = function(formCartao) {
      if ($scope.formaPagamento !== 2) {
        formCartao.$submitted = false;
        $scope.nomeCartao = '';
        $scope.numeroCartao = '';
        $scope.mesValidade = '';
        $scope.anoValidade = '';
        $scope.codigoSeguranca = '';
      }
    };

    Pedido.getPedidoAsync().then(function(pedido) {
      $scope.isPJ = pedido.cliente.cnpj ? true : false;
      $scope.cpfcnpj = pedido.cliente.cpf || pedido.cliente.cnpj;
      $scope.razaoSocial = pedido.cliente.razaoSocial;
      $scope.inscricaoEstadual = pedido.cliente.inscricaoEstadual;

      definirDisabled();
      definirCheckNF();
      verificaTex(pedido.remessas);
    });

    $q.all([Pagamento.busca(), Perfil.getUserData()])
      .then(function (data) {
        var cartao = data[0];
        var plano;
        if (!data[1].planoContrato.tipo) {
          plano = 'flex';
        } else {
          plano = data[1].planoContrato.tipo.toLowerCase();
        }
        trocaTexto(cartao);
        if (cartao.formaPagamento !== null) {
          idFormaPagamento = cartao.formaPagamento.id;
          if (cartao.formaPagamento.dataHoraUsarComoPadrao !== null) {
            montarOptions(true, cartao, plano);
            cartaoHabilitado = true;
          } else {
            montarOptions(false, cartao, plano);
            cartaoHabilitado = false;
          }
        } else {
          montarOptions(null, null, plano);
          cartaoHabilitado = false;
        }
      })
      .catch(function(error) {
        $scope.tratarErrosBackEnd(error);
      });

    function finalizarPagamento(pedido, formaPagamento, codigoCupom) {
      $state.go('pedido.resumo');
    }

    function updatePayment(cliente, formaPagamento, novoCartao, idFormaPagamento) {
      var pedido = Pedido.getPedido();

      var clienteAtualizado = {
        id: Auth.getCurrentUser().id,
        cpf: cliente.cpf,
        cnpj: cliente.cnpj,
        razaoSocial: cliente.razaoSocial,
        inscricaoEstadual: cliente.inscricaoEstadual,
        codigoCupom: cliente.codigoCupom,
        pj: cliente.pj
      };

      Cliente.atualizar(clienteAtualizado)
        .then(function(clienteRetornado) {
          // altera a propriedade PJ do user no LS.
          Auth.setPJ(clienteRetornado.pj);

          // se forma pagamento foi Cartao.
          // senao se Boleto e cartao habilitado.
          if (formaPagamento === 'Cartao') {
            // se atualizou/criou cartao.
            // senao se utilizou cartao e esta desabilitado.
            if (novoCartao != null) {
              Pagamento.criaAtualiza(novoCartao)
                .then(function() {
                  finalizarPagamento(pedido, formaPagamento, clienteRetornado.codigoCupom);
                })
                .catch(function(error) {
                  if (error.status === 422) {
                    $scope.tratarErrosBackEnd(error);
                  }
                });
            } else if (novoCartao == null && !cliente.cartaoHabilitado) {
              Pagamento.habilita(idFormaPagamento)
                .then(function() {
                  finalizarPagamento(pedido, formaPagamento, clienteRetornado.codigoCupom);
                });
            } else if (novoCartao == null && cliente.cartaoHabilitado) {
              finalizarPagamento(pedido, formaPagamento, clienteRetornado.codigoCupom);
            }

          } else if (formaPagamento === 'Boleto' && cliente.cartaoHabilitado) {
            Pagamento.desabilita(idFormaPagamento)
              .then(function() {
                finalizarPagamento(pedido, formaPagamento, clienteRetornado.codigoCupom);
              });
          } else if (formaPagamento === 'Boleto' && !cliente.cartaoHabilitado) {
            finalizarPagamento(pedido, formaPagamento, clienteRetornado.codigoCupom);
          }
        })
        .catch($scope.tratarErrosBackEnd);
    }

    $scope.submeterFormaPagamento = function(formSelect, formCartao, formCpf, forceValidation, forceObj) {
      // submete formSelect.
      if (formSelect) {
        formSelect.$submitted = true;
      }

      // se formSelect e formCpf estão válidos.
      if (((formSelect && formSelect.$valid) && (formCpf && formCpf.$valid)) || forceValidation) {

        // monta um objeto com os dados do cliente.
        var cliente = forceObj ? forceObj : {
          cpf: $scope.cpfcnpj.length == 11 ? $scope.cpfcnpj : null,
          cnpj: $scope.cpfcnpj.length == 14 ? $scope.cpfcnpj : null,
          razaoSocial: $scope.cpfcnpj.length != 14 ? null : $scope.razaoSocial,
          inscricaoEstadual: $scope.cpfcnpj.length != 14 ? null : $scope.inscricaoEstadual,
          codigoCupom: $scope.codigoCupom,
          cartaoHabilitado: cartaoHabilitado,
          pj: $scope.checkPJ.value
        };

        // se utilizou boleto a ultima vez e tem cartao desabilitado
        // ou se utilizou cartao habilitado pela segunda vez.
        // senao se Adicionou ou Alterou cartão.
        // senao se esta usando boleto.
        if (forceValidation) {
          updatePayment(cliente, 'Boleto', null, idFormaPagamento);
        } else {
          if ($scope.formaPagamento === 0 || $scope.formaPagamento === 1) {
            updatePayment(cliente, 'Cartao', null, idFormaPagamento);
          } else if ($scope.formaPagamento === 2 || $scope.formaPagamento === 4) {
            // submete formCartao.
            formCartao.$submitted = true;

            // se formCartao está válido.
            if (formCartao.$valid) {
              var cartao = {
                  "numero": $scope.numeroCartao,
                  "codigoSeguranca": $scope.codigoSeguranca,
                  "nome": $scope.nomeCartao,
                  "sobrenome": Utils.getSobrenome($scope.nomeCartao),
                  "mesValidade": parseInt($scope.mesValidade),
                  "anoValidade": parseInt($scope.anoValidade),
                  "cpf": cliente.cpf ? cliente.cpf : cliente.cnpj
                }
                // Emite evento para o pedido controller atualizar/criar o cartao.
              updatePayment(cliente, 'Cartao', cartao, null);
            }
          } else if ($scope.formaPagamento === 3) {
            // Emite evento para o pedido controller atualizar o cliente e desabilitar o boleto.
            updatePayment(cliente, 'Boleto', null, idFormaPagamento);
          }
        }
      }
    };

    $scope.decada = function() {
      var date = new Date(),
        currentYear = date.getFullYear(),
        year = [currentYear],
        i = 0;
      for (i; i <= 9; i++) {
        year.push(currentYear + 1);
        currentYear++;
      }

      return year;
    };

    $scope.tratarErrosBackEnd = function(err) {
      $scope.errors = {};
      if (err != null && err.erro) {
        $scope.addAlert(err.erro);
      } else if (err != null && err[0] != null) {
        $scope.addAlert(err[0].message || err[0].erro);
      } else if (err.data && err.data.erro) {
        $scope.addAlert(err.data.erro);
      } else if (err.data && err.data.length) {
        for (var erro in err.data) {
          $scope.$emit('erroEncontrado', err.data[erro].message);
        }
      }
    };

  }

  angular
    .module('mandaeApp')
    .controller('PagamentoCtrl', PagamentoCtrl);

}());
